import React, { Component } from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  page: {
    minHeight: '100vh',
    height: '100%',
    position: 'relative',
    padding: 24,
    '& h1': {
      color: '#7c7c7c',
      fontSize: 18,
      textTransform: 'uppercase',
      marginBottom: 10,
      marginTop: 10,
    },
    '& h2': {
      color: '#7c7c7c',
      fontSize: 13,
    },
  },
  '@global': {
    select: {
      backgroundColor: '#f8f8f8',
      borderColor: '#e3e5e7',
      padding: 11,
      paddingRight: 40,
      appearance: 'none',
      backgroundImage:
        'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAClSURBVHgBnY4xDsIwDEXtSDBzhLJVsDABI70BcAGUkwAn4QaQG2SHJVPFmCN0YqDCxpGIVNJM9RI5fs/fWC62BY7wwi3rpzMeMjVb7o/hre/XM85XO8uMG+k9valKpR98Aobm1dJUfZA1CyyfhRorGxJzMABV3pkGw6Bcy1mkrDRFTBL50IXrh3GBxbitK6FAjDBJ4T+hl5SBe0KUFOENmHUKD6ovXFRW1gg3zEMAAAAASUVORK5CYII=)',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 10px center',
    },
    input: {
      backgroundColor: '#f8f8f8',
      padding: 11,
      paddingRight: 40,
      appearance: 'none',
      border: '1px solid #e3e5e7',
      borderRadius: 5,
    },
  },
}

var poppinsFontLink = null

class StatsPageWrapper extends Component {
  componentDidMount = () => {
    // <link href="https://fonts.googleapis.com/css?family=Poppins" rel="stylesheet">
    if (poppinsFontLink) return
    poppinsFontLink = document.createElement('link')
    poppinsFontLink.href = 'https://fonts.googleapis.com/css?family=Poppins'
    poppinsFontLink.rel = 'stylesheet'
    document.head.appendChild(poppinsFontLink)
  }

  render = () => {
    const { classes, className, ...otherProps } = this.props

    return (
      <div {...otherProps} className={classNames(classes.page, className)} />
    )
  }
}

export default injectStyles(styles)(StatsPageWrapper)

//<link href="https://fonts.googleapis.com/css?family=Poppins" rel="stylesheet">



// WEBPACK FOOTER //
// ./src/Components/Page/StatsPageWrapper/StatsPageWrapper.js